import React from "react";
import { Chip } from "@mui/material";
import { cn } from "../utils/utils";
import Tick from "../assets/svgs/tick.svg";
import Cross from "../assets/svgs/cross.svg";

const CUSTOM_CUT_LABELS = {
  ex: "EX",
  vg: "VG",
  gd: "GD",
  "l-ex": "L-EX",
  "l-vg": "L-VG",
  "l-gd": "L-GD",
};

const CustomCutFilter = ({ grades, selectedGrade, onSelect }) => {
  if (!grades || Object.keys(grades).length === 0) return null;

  const handleClick = (grade) => {
    // Toggle behavior: if already selected, deselect; otherwise select new one
    onSelect(selectedGrade === grade ? null : grade);
  };

  return (
    <>
      <div className="h-[1px] w-full border-x-0 border-t-0 border-b border-solid border-[#D8D8D8] px-2" />
      <div className="my-0 px-2 mb-2">
        <div className="flex justify-between items-start">
          <label style={{ fontWeight: "bold", color: "gray", fontSize: "12px", marginBottom: "5px" }}>
            CUSTOM CUT
          </label>
        </div>
        <div className="mt-0">
          {Object.keys(grades).map((grade) => {
            const isSelected = selectedGrade === grade;
            const displayLabel = CUSTOM_CUT_LABELS[grade] || grade.toUpperCase();
            return (
              <Chip
                key={grade}
                onClick={() => handleClick(grade)}
                className={cn(
                  "m-1 p-0 cursor-pointer",
                  isSelected ? "bg-[#A4D9FF]" : "bg-[#F2F2F2]"
                )}
                size="small"
                label={
                  <div className="flex justify-center items-center gap-1">
                    <h5
                      className={cn(
                        "font-bold text-[0.6rem] m-0",
                        isSelected ? "text-[#0075FF]" : "text-[black]"
                      )}
                    >
                      {displayLabel}
                    </h5>
                    {isSelected ? (
                      <img src={Tick} style={{ width: "14px", height: "14px" }} />
                    ) : (
                      <img src={Cross} style={{ width: "14px", height: "14px" }} className="bg-[#F2F2F2]" />
                    )}
                  </div>
                }
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default CustomCutFilter;
